import axios from "../axios";
import { normalizeHseGoal, normalizeHseGoalsList, toHseGoalPayload } from "../../components/dashboard/hse/hseGoalsUtils";
import { downloadHsePdfBlob, raiseHsePdfRequestError } from "./downloadPdf";

const GOALS_PATH = "/hse/goals";

function unwrap(response) {
  return response.data?.data || response.data;
}

function raiseApiError(error) {
  const errors = error?.response?.data?.errors;
  const message = Array.isArray(errors)
    ? errors.join(", ")
    : error?.response?.data?.message || error?.message || "error";
  const next = new Error(message);
  next.response = error?.response;
  throw next;
}

export async function fetchHseGoals(params = {}) {
  try {
    const response = await axios.get(GOALS_PATH, {
      params: { per_page: 100, ...params },
    });
    return {
      data: normalizeHseGoalsList(response.data?.data || []),
      meta: response.data?.meta || {},
    };
  } catch (error) {
    raiseApiError(error);
  }
}

export async function fetchHseGoal(id) {
  try {
    const response = await axios.get(`${GOALS_PATH}/${id}`);
    return normalizeHseGoal(unwrap(response));
  } catch (error) {
    raiseApiError(error);
  }
}

export async function createHseGoal(goal) {
  try {
    const response = await axios.post(GOALS_PATH, { goal: toHseGoalPayload(goal) });
    return normalizeHseGoal(unwrap(response));
  } catch (error) {
    raiseApiError(error);
  }
}

export async function updateHseGoal(id, goal) {
  try {
    const response = await axios.put(`${GOALS_PATH}/${id}`, { goal: toHseGoalPayload(goal) });
    return normalizeHseGoal(unwrap(response));
  } catch (error) {
    raiseApiError(error);
  }
}

export async function saveHseGoal(goal) {
  if (goal?.id) return updateHseGoal(goal.id, goal);
  return createHseGoal(goal);
}

export async function deleteHseGoal(id) {
  try {
    const response = await axios.delete(`${GOALS_PATH}/${id}`);
    return response.data;
  } catch (error) {
    raiseApiError(error);
  }
}

export async function approveHseGoal(id) {
  try {
    const response = await axios.post(`${GOALS_PATH}/${id}/approve`);
    return normalizeHseGoal(unwrap(response));
  } catch (error) {
    raiseApiError(error);
  }
}

export async function signHseGoal(id) {
  try {
    const response = await axios.post(`${GOALS_PATH}/${id}/sign`);
    return normalizeHseGoal(unwrap(response));
  } catch (error) {
    raiseApiError(error);
  }
}

export async function exportHseGoalPdf(id, filename) {
  try {
    const response = await axios.get(`${GOALS_PATH}/${id}/export_pdf`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    });
    await downloadHsePdfBlob(response.data, filename || `hse-goal-${id}.pdf`);
  } catch (error) {
    await raiseHsePdfRequestError(error);
  }
}
